import { calculateAge } from '@/helpers/common';

export default {
  computesRequired: true,
  params: ['relatedField', 'dateOfInsuranceStart'],
  validate (value, { relatedField, dateOfInsuranceStart }) {
    const { age } = calculateAge(value, dateOfInsuranceStart, this.constants.DATE_OF_INSURANCE_START_MAX_DAYS);

    if (age && +relatedField > age - this.constants.INSURER_MIN_AGE) return false;

    return true;
  },
};
